module.exports = __webpack_public_path__ + "img/instagram-arica.209133d8.png";